import { ref, shallowRef } from 'vue';
import { createGlobalState } from '@vueuse/core';
import { headerService } from '@/services/header-service';

export const defaultHeaderServiceData = {
    isSpecialIp: true,
    siteRegion: 'CN',
    email: '',
    mobileNumber: '',
    isHighLevelWhiteLabel: false,
};

/**
 *
 * @param data 初始值
 * @returns
 */
export const useHeaderService = createGlobalState(() => {
    const data = defaultHeaderServiceData;
    const isSpecialIp = ref(data.isSpecialIp);
    const siteRegion = ref(data.siteRegion);
    const email = ref(data.email);
    const mobileNumber = ref(data.mobileNumber);
    const isHighLevelWhiteLabel = ref(data.isHighLevelWhiteLabel);

    const isLoading = ref(false);
    const isReady = ref(false);
    const error = shallowRef<unknown|undefined>(undefined);

    async function execute() {
        if (isLoading.value) {
            return;
        }
        isLoading.value = true;
        try {
            await headerService.deferred.promise;
            isSpecialIp.value = headerService.account?.isSpecialIp || false;
            siteRegion.value = headerService.account?.siteRegion || 'CN';
            email.value = headerService.account?.email || '';
            mobileNumber.value = headerService.account?.mobileNumber || '';
            isHighLevelWhiteLabel.value = headerService.account?.isHighLevelWhiteLabel || false;
            isReady.value = true;
        } catch (err) {
            error.value = err;
        } finally {
            isLoading.value = false;
        }
    }

    execute();

    return {
        execute,
        isSpecialIp,
        siteRegion,
        email,
        mobileNumber,
        isHighLevelWhiteLabel,
        isLoading,
        isReady,
        error,
    };
});
